import { render } from "./CartIcon.vue?vue&type=template&id=21b960f4"
const script = {}

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__